import { z } from 'zod';
import { IsoDateTimeSchema, UuidSchema } from './common.js';

export const PhaseDueMeaningSchema = z.enum(['none', 'erstgespraech', 'kickoff', 'fertigstellung']);
export type PhaseDueMeaning = z.infer<typeof PhaseDueMeaningSchema>;

export const PhaseSchema = z.object({
  phase_id: UuidSchema,
  name: z.string().min(1),
  order: z.number().int().nonnegative(),
  description: z.string().optional(),
  required_fields: z.array(z.string()).optional(),
  entry_required_fields: z.array(z.string()).optional(),
  task_template: z
    .array(
      z.object({
        title: z.string(),
        description: z.string().optional(),
      }),
    )
    .optional(),
  /** Bedeutung des Faelligkeitsdatums in dieser Phase (Spec 2026-09-16). */
  due_meaning: PhaseDueMeaningSchema.optional(),
  created_at: IsoDateTimeSchema,
  updated_at: IsoDateTimeSchema,
});
export type Phase = z.infer<typeof PhaseSchema>;

export const CreatePhaseInputSchema = PhaseSchema.omit({
  phase_id: true,
  created_at: true,
  updated_at: true,
});
export type CreatePhaseInput = z.infer<typeof CreatePhaseInputSchema>;

export const UpdatePhaseInputSchema = PhaseSchema.partial().required({
  phase_id: true,
});
export type UpdatePhaseInput = z.infer<typeof UpdatePhaseInputSchema>;
